
/**
 * @Description 基本信息
 */
import { FC } from 'react';

import styles from '../index.module.less';
import V2Popover from '@/common/components/Popover/Popover';
import { Col, Row } from 'antd';
import Info from '../../../components/Info';
import { beautifyThePrice } from '@lhb/func';

interface BaseInfoModuleProps {
  data: any;
  level?: 1 | 2 | 3; // 1 全国， 2 省视图， 3 市视图
}

const showProvinceMaxRank = 10; // 省份排名前10才显示
const showCityMaxRank = 20; // 城市排名前20才显示

const BaseInfoModule: FC<BaseInfoModuleProps> = ({ data, level }) => {
  // const num = 1;
  const renderTag = (field) => {
    const name = level === 2 ? '全国省份' : '全国城市';
    const maxRank = level === 2 ? showProvinceMaxRank : showCityMaxRank;
    return data[field] && +data[field] <= maxRank ? <V2Popover content={`${name}排名第${data[field]}名`}>
      <div className={styles.renderTag}>NO.{data[field]}</div>
    </V2Popover> : <></>;
  };

  const infoFactor = (info) => {
    if (!info) {
      return '-';
    } else if (+info === parseInt(info)) {
      return beautifyThePrice(info, undefined, 0);
    } else if (Number(info) <= 0.05) {
      // 小于等于0.05时直接显示0.05
      return info;
    } else {
      return beautifyThePrice(info, undefined, 1);
    }
  };

  return (
    <Row gutter={[8, 8]} className={styles.statisticRow}>
      <Col span={5}>
        <Info text={`常住人口`} num={infoFactor(data?.population)} unit='万人' icon='iconic_renkou' labelSuffix={renderTag('populationRank')}></Info>
      </Col>
      <Col span={5}>
        <Info text={level === 2 ? '全省GDP' : '全市GDP' } num={infoFactor(data?.gdp)} unit='亿元' icon='iconic_GDP' labelSuffix={renderTag('gdpRank')}></Info>
      </Col>
      <Col span={5}>
        <Info text='人均GDP' num={infoFactor(data?.avgGdp)} unit='万元' icon='iconic_renjun' labelSuffix={renderTag('avgGdpRank')}></Info>
      </Col>
      <Col span={5}>
        <Info text='GDP增速' num={infoFactor(data?.gdpGrowthRate)} unit='%' icon='iconic_suzeng' labelSuffix={renderTag('gdpGrowthRank')}></Info>
      </Col>
      <Col span={5}>
        <Info text='商业情况' num={infoFactor(data?.shoppingCenterCount)} unit='家购物中心' icon='iconic_shangyeqingkuang' labelSuffix={renderTag('shoppingCenterCountRank')}></Info>
      </Col>
    </Row>
  );
};

export default BaseInfoModule;
